export const environment = {
  production: true,
  serviceBaseUrl: 'https://citazen.co.za/api/msz/' 
};
